import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    usersControllerListTelegramUsersV1: build.query<
      UsersControllerListTelegramUsersV1ApiResponse,
      UsersControllerListTelegramUsersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-users`,
        params: {
          domain: queryArg.domain,
          mode: queryArg.mode,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type UsersControllerListTelegramUsersV1ApiResponse =
  /** status 200 Returns the users selectable for the requested operation. Both modes answer in the same shape */ ListTelegramUsersResponse;
export type UsersControllerListTelegramUsersV1ApiArg = {
  domain?: 'loans' | 'retainers' | 'all';
  mode?: 'add' | 'remove';
};
export type ListTelegramUsersResponse = {
  /** Auth user id — the value to send as userIds */
  id: number;
  fullname: string;
  email: string;
  company: string;
  telegramChatID: string;
  /** Holds telegram.admin, so adding them to a group also promotes them to group admin */
  isTelegramAdmin: boolean;
}[];
